// extracted by mini-css-extract-plugin
module.exports = {"card":"_5a68394","eachWay":"_307a80b"};